<template>
  <div class="min-h-screen bg-gray-50 p-6" @keydown="handleKeyPress">

    

    <!-- Settings Grid -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <!-- General Settings -->
      <div class="bg-white shadow-sm rounded-lg p-6">
        <h3 class="text-lg font-medium text-gray-900 mb-4">General Settings</h3>
        
        <div class="space-y-6">
          <!-- Elementor Toggle -->
          <div class="flex items-center justify-between">
            <div>
              <label class="text-sm font-medium text-gray-700">Elementor Enabled</label>
              <p class="text-sm text-gray-500">Enable SmartPress in Elementor editor</p>
            </div>
            <label class="relative inline-flex items-center cursor-pointer">
              <input type="checkbox" class="sr-only peer" v-model="customFields.elementor_enabled" @change="saveCustomFields">
              <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
            </label>
          </div>

          <!-- Gutenberg Toggle -->
          <div class="flex items-center justify-between">
            <div>
              <label class="text-sm font-medium text-gray-700">Gutenberg Enabled</label>
              <p class="text-sm text-gray-500">Enable SmartPress in Gutenberg editor</p>
            </div>
            <label class="relative inline-flex items-center cursor-pointer">
              <input type="checkbox" class="sr-only peer" v-model="customFields.gutenberg_enabled" @change="saveCustomFields">
              <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
            </label>
          </div>

          <!-- Image Generation Toggle -->
          <div class="flex items-center justify-between">
            <div>
              <label class="text-sm font-medium text-gray-700">Image Generation</label>
              <p class="text-sm text-gray-500">Enable AI image generation features</p>
            </div>
            <label class="relative inline-flex items-center cursor-pointer">
              <input type="checkbox" class="sr-only peer" v-model="customFields.image_generation" @change="saveCustomFields">
              <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
            </label>
          </div>

          <!-- Popup on Selection Toggle -->
          <div class="flex items-center justify-between">
            <div>
              <label class="text-sm font-medium text-gray-700">Popup on Selection</label>
              <p class="text-sm text-gray-500">Show SmartPress popup when text is selected</p>
            </div>
            <label class="relative inline-flex items-center cursor-pointer">
              <input type="checkbox" class="sr-only peer" v-model="customFields.on_selection" @change="saveCustomFields">
              <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
            </label>
          </div>
        </div>
      </div>

      <!-- Chat Settings -->
      <div class="bg-white shadow-sm rounded-lg p-6">
        <h3 class="text-lg font-medium text-gray-900 mb-4">Chat Settings</h3>
        
        <div class="space-y-6">
          <!-- Global Chat Toggle -->
          <div class="flex items-center justify-between">
            <div>
              <label class="text-sm font-medium text-gray-700">Global Chat</label>
              <p class="text-sm text-gray-500">Enable SmartPress chat everywhere in WordPress Dashboard</p>
            </div>
            <label class="relative inline-flex items-center cursor-pointer">
              <input type="checkbox" class="sr-only peer" v-model="customFields.global_chat" @change="saveCustomFields">
              <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
            </label>
          </div>

          <!-- Application Key -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Application Key</label>
            <input 
              type="text" 
              v-model="customFields.application_key"
              @change="saveCustomFields"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
              placeholder="Enter your application key"
            >
            <p class="mt-2 text-sm text-gray-500">Your Wordpress application key for authentication (Username:Application Password). You can create one from <a href="/wp-admin/profile.php" target="_blank">Edit Profile</a></p>
          </div>

          <!-- Site URL - Hidden by default, shown in debug mode -->
          <div v-if="debugMode">
            <label class="block text-sm font-medium text-gray-700 mb-1">Site URL</label>
            <input 
              type="text" 
              v-model="customFields.site_url"
              @change="saveCustomFields"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
              placeholder="Enter site URL"
            >
            <p class="mt-2 text-sm text-gray-500">Debug only: Override the site URL</p>
          </div>
        </div>
      </div>
    </div>

     <!-- Save Status -->
     <div v-if="saveStatus" class="fixed bottom-4">
      <div :class="['px-4 py-2 rounded-lg shadow-lg', 
        saveStatus.type === 'success' ? 'bg-green-500 text-white' : 'bg-red-500 text-white']">
        {{ saveStatus.message }}
      </div>
    </div>


    <!-- Smart Content Personalization - Brand Data -->
    <div class="bg-secondary shadow-sm rounded-lg p-6 mt-4">
      <div class="flex items-center justify-between mb-2">
        <div>
          <h3 class="text-lg font-medium !text-gray-200">Smart Content Personalization - Brand Data</h3>
          <p class="text-sm text-gray-200 mb-4">This will be used to feed your brand data to the AI to personalize the content for your brand.</p>
        </div>
        <div>
          <button @click="trainAI" ref="trainAIButton" class="btn btn-primary border-none !bg-primary !text-white !tooltip !tooltip-left !tooltip-secondary" data-tip="Get AI to understand your brand with one click.">Train AI on Your website Data</button>
          <p class="text-gray-300 !text-[10px]">Training on {{customWebsiteUrl}} <span class="text-primary cursor-pointer hover:underline" @click="showCustomUrlField = true">Edit</span></p>
        </div>
      </div>
     
      
      <!-- Custom Website URL input - only shown after training failure -->
      <div v-if="showCustomUrlField" class="mb-4">
        <label class="block text-sm font-medium text-gray-200 mb-1">Custom Website URL</label>
        <input 
          type="text" 
          v-model="customWebsiteUrl"
          class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
          placeholder="Enter website URL"
        >
        <p class="mt-1 text-sm text-gray-300">Enter a custom website URL for AI training</p>
      </div>
      
      <div class="w-full" :class="{'tooltip tooltip-bottom tooltip-warning': currentUser.plan == 'free'}"
      :data-tip="currentUser.plan == 'free' ? 'Editable only in paid plans' : ''">
        <textarea 
          v-model="customFields.brand_data" 
          @change="saveCustomFields"
          @input="updateCharCount"
          class="mt-1 !p-10 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
          placeholder=".."
          rows="10"
          maxlength="3000"
          :class="{'cursor-not-allowed': currentUser.plan == 'free'}"
          :disabled="currentUser.plan == 'free'"
        >
        </textarea>
        <div class="flex justify-end items-center mt-2 space-x-3">
          <button 
            v-if="contentUpdated" 
            @click="saveCustomFields" 
            class="px-3 py-1 bg-primary border-none text-white text-sm rounded-md hover:bg-primary-dark transition-colors"
          >
            Save Updates
          </button>
          <span class="text-sm" :class="{'text-red-500': charCount > 2500, 'text-gray-400': charCount <= 3000}">
            {{ charCount }}/3000 characters
          </span>
        </div>
      </div>
    </div>

   
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'AdminSettings',
  data() {
    return {
      customFields: {
        application_key: '',
        elementor_enabled: false,
        global_chat: false,
        gutenberg_enabled: false,
        image_generation: false,
        on_selection: false,
        site_url: ''
      },
      saveStatus: null,
      charCount: 0,
      contentUpdated: false,
      originalBrandData: '',
      showCustomUrlField: false,
      customWebsiteUrl: window.location.origin,
      currentUser: localStorage.getItem('smartpress_current_user') ? JSON.parse(localStorage.getItem('smartpress_current_user')) : {},
      debugMode: false,
      keySequence: '',
    }
  },
  created() {
    this.fetchCustomFields();
  },
  methods: {
    updateCharCount() {
      this.charCount = this.customFields.brand_data ? this.customFields.brand_data.length : 0;
      this.contentUpdated = this.customFields.brand_data !== this.originalBrandData;
    },
    async fetchCustomFields() {
      try {
       
        const response = await fetch(`/wp-json/smartpress/v1/custom-fields`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-WP-Nonce': window.smartpress_wpApiSettings?.nonce || ''
          }
        });
        
        if (!response.ok) {
          throw new Error('Failed to fetch custom fields');
        }
        
        const data = await response.json();
        this.customFields = { ...this.customFields, ...data };
        this.originalBrandData = this.customFields.brand_data || '';
        this.updateCharCount();
        console.log('customFields', this.customFields);
      
      } catch (error) {
        console.error('Error fetching custom fields:', error);
        this.showStatus('Failed to load settings', 'error');
      }
    },
    
    async saveCustomFields() {
      try {
        const response = await fetch(`/wp-json/smartpress/v1/custom-fields`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-WP-Nonce': window.smartpress_wpApiSettings?.nonce || ''
          },
          body: JSON.stringify(this.customFields)
        });
        
        if (!response.ok) {
          throw new Error('Failed to save settings');
        }
        // update custom fields in local storage
        localStorage.setItem('smartpress_custom_fields', JSON.stringify(this.customFields));
        this.originalBrandData = this.customFields.brand_data || '';
        this.contentUpdated = false;
        this.showStatus('Settings saved successfully', 'success');
      } catch (error) {
        console.error('Error saving custom fields:', error);
        this.showStatus('Failed to save settings', 'error');
      }
    },
    
    showStatus(message, type) {
      this.saveStatus = { message, type };
      setTimeout(() => {
        this.saveStatus = null;
      }, 8000);
    },
    
    async trainAI() {
      // Hide custom URL field when starting training
      this.showCustomUrlField = false;
      
      // deactivate button
      this.$refs.trainAIButton.disabled = true;
      this.$refs.trainAIButton.innerHTML = 'Training<span class="ml-2 loading loading-dots loading-sm"></span>';
      this.$refs.trainAIButton.classList.add('!opacity-50');

      // get website url - use custom URL if provided, otherwise use current origin
      const websiteUrl = this.customWebsiteUrl || window.location.origin;
      
      // check if websiteUrl is localhost
      if (websiteUrl.includes('localhost')) {
        this.showStatus('Please use a live website to train the AI', 'error');
        this.showCustomUrlField = true;
        this.$refs.trainAIButton.disabled = false;
        this.$refs.trainAIButton.innerHTML = 'Train AI on Your website Data';
        this.$refs.trainAIButton.classList.remove('!opacity-50');
        return;
      }
      
      try {
        // send websiteUrl to server
        const response = await axios.post('https://node.10g8.com/webhook/14a134f2-33f3-4c5c-be5b-58d0a4eb3f2f', { "website": websiteUrl });
        this.showStatus('AI trained successfully', 'success');
        // console.log('response', response);
        // convert response.output to json
        const brandData = response.data.output;
        this.customFields.brand_data = brandData;
        this.saveCustomFields();
      } catch(error) {
        this.showStatus(`Failed to train AI, Please check your website ${websiteUrl} is live, or try a different website for training below.`, 'error');
        // Show custom URL input field after failure
        this.showCustomUrlField = true;
        this.customWebsiteUrl = window.location.origin;
      } finally {
        this.$refs.trainAIButton.disabled = false;
        this.$refs.trainAIButton.innerHTML = 'Train AI on Your website Data';
        this.$refs.trainAIButton.classList.remove('!opacity-50');
      }
    },
    handleKeyPress(event) {
      // Add the key to our sequence
      this.keySequence += event.key.toLowerCase();
      
      // Only keep the last 5 characters to avoid memory issues with long sequences
      if (this.keySequence.length > 5) {
        this.keySequence = this.keySequence.substring(this.keySequence.length - 5);
      }
      
      // Check if the sequence ends with "debug"
      if (this.keySequence.endsWith('debug')) {
        this.debugMode = true;
        this.showStatus('Debug mode activated', 'success');
        // Reset the sequence
        this.keySequence = '';
      }
    },
  }
}
</script>

<style scoped>
</style> 